// Hostname
export const HOSTNAME = `${process.env.NEXT_PUBLIC_AD_FRONT_APP_HOST}`?.slice(
    0,
    -1
);

export const AUTH_REDIRECT_URL = `${HOSTNAME}/auth/`;
export const USER_IDENTITY_CONFIG = {
    ACKO_HOSTNAME: process.env.NEXT_PUBLIC_ACKO_HOST,
    CLIENT_ID: process.env.NEXT_PUBLIC_AD_CLIENT_ID,
    RESPONSE_TYPE: 'code',
    IDENTITY_TYPE: 'd2c',
    SCOPE: 'offline_access',
    REALM: process.env.NEXT_PUBLIC_AD_REALM,
};

export const JWT_COOKIE_KEY = 'ackodrive_tokens';
export const JWT_EXPIRE_DAYS = 14;
export const ACKO_DRIVE_ENDPOINT = process.env.NEXT_PUBLIC_ACKO_DRIVE_API_IP;
export const REMOVE_JWT_TOKENS = 'api/logout';
export const JWT_HEADER = 'RetailToken';
export const COOKIES = 'cookies';

export const VEHICLE_SOURCE = 'acko_adsc';
